export enum ProfileTabs {
  PROFILE = 'profile',
  NOTIFICATIONS = 'notifications',
  SECURITY = 'security',
  BILLING = 'billing',
  INVOICE = 'invoice',
  CALENDAR = 'calendar',
  REFERRAL = 'referral'
}
